import {Button, type ButtonProps} from '@/components/ui/button';
import {Loader2} from 'lucide-react';

export interface LoadingButtonProps extends ButtonProps {
  loading: boolean;
}

export default function LoadingButton(props: LoadingButtonProps) {
  const {children, loading, ...rest} = props;

  return (
    <Button {...rest} disabled={loading}>
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </Button>
  );
}
